<template>
  <div class="ad-container flex flex-y">
    <div class="padding-lr-16">
      <div v-if="list.length != 0" class="margin-top-20">
        <div class="ad-body-box">
          <van-pull-refresh
            v-model="refreshing"
            success-text="刷新成功"
            @refresh="onRefresh"
          >
            <van-list
              class="list-container"
              v-model="listLoading"
              :finished="finished"
              :error.sync="error"
              :immediate-check="false"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-radio-group
                v-model="radioData"
                ref="checkboxGroup"
                class="padding-14"
                @change="onChange"
              >
                <van-radio
                  v-for="items in list"
                  :key="items.id"
                  :name="items.id"
                  v-model="checkedArr"
                  class="padding-bottom-14"
                >
                  <div class="flex flex-1 align-center">
                    <div class="flex-1 margin-right-4">
                      <div>
                        <div class="flex align-center">
                          <div class="greenDot"></div>
                          <div
                            class="flex-1 margin-left-4 text-over"
                            style="width: 0"
                          >
                            {{ items.startAddress }}
                          </div>
                        </div>
                        <div class="flex align-center">
                          <div class="redDot"></div>
                          <div
                            class="flex-1 text-over margin-left-4"
                            style="width: 0"
                          >
                            {{ items.endAddress }}
                          </div>
                        </div>
                        <div class="flex text-12 bottom text-grey">
                          <div>{{ items.startRunTime }}</div>
                          <div class="distance-top"></div>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                      <span class="text-20 text-primary">{{
                        items.realPayMoney
                      }}</span
                      ><span class="text-12">元</span>
                    </div>
                  </div>
                </van-radio>
              </van-radio-group>
            </van-list>
          </van-pull-refresh>
        </div>
        <div
          class="flex justify-between padding-10 footer"
          v-if="list.length != 0"
        >
          <van-checkbox
            v-model="AllChecked"
            icon-size="20px"
            class="flex justify-between"
          >
            <div class="flex justify-between margin-top-16">
              <div class="line"></div>
              <div class="flex justify-between distance-left">
                <p>
                  <span>{{ result.length }}</span
                  >个行程，
                </p>
                <p class="distance-left text-primary">
                  共{{ totalPayMoney }}元
                </p>
              </div>
            </div>
          </van-checkbox>
          <div class="distance-left-right margin-top-20">
            <van-button
              type="warning"
              :disabled="result.length === 0"
              class="button"
              @click="go()"
              >去开发票</van-button
            >
          </div>
        </div>
      </div>
      <div v-if="list.length === 0" class="nullDate">
        <van-empty description="暂无可开具的发票" />
      </div>
    </div>
  </div>
</template>

<script>
import { getList } from 'api/invoice'
import floatOption from '@/utils/float'
import Vue from 'vue'
import { List, PullRefresh } from 'vant'

Vue.use(List).use(PullRefresh)
export default {
  data () {
    return {
      error: false,
      listLoading: false,
      finished: false,
      refreshing: false,
      calcSum: 0,
      checkedArr: [],
      selectedData: [],
      result: [],
      list: [],
      radioData:null,//单选数据
      newArr: [],
      isChecked: true,
      AllChecked: false,
      checked: false,
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      params: {
        current: 1,
        size: 10,
        pages: 1
      }
    }
  },
  created () {
    this.getList(true)
  },
  onLoad () {
    this.getList()
  },
  computed: {
    totalPayMoney () {
      console.log(this.result);
      return this.result.reduce((pre, current) => {
        const index = this.list.findIndex(item => item.id === current)
        this.checkedArr.push(this.list[index])
        return floatOption(pre, this.list[index].realPayMoney, 'add')
      }, 0)
    },
    newdata () {
      var res = []
      for (var i in this.list) {
        var _data = this.list[i]
        var index = this.result.indexOf(_data.id)
        if (index !== -1) {
          res.push(_data)
        }
      }
      return res
    }
  },
  methods: {
    onRefresh () {
      this.params.current = 1
      this.getList()
    },
    onLoad () {
      this.getList()
    },
    go: function () {
      var res = []
      for (var i in this.list) {
        var _data = this.list[i]
        var index = this.result.indexOf(_data.id)
        if (index !== -1) {
          res.push(_data)
        }
      }
      window.localStorage.setItem('detail', JSON.stringify(res))
      this.$router.push({
        name: 'InvoiceSubmitpage',
        params: {
          all: this.result.length,
          money: this.totalPayMoney,
          id: JSON.stringify(this.result),
          checkedArr: JSON.stringify(res)
        }
      })
    },
    onChange (selectList) {
      console.log("选择");
      console.log(this.radioData);
      this.result = [];
      this.result.push(this.radioData)
      console.log(selectList);
      this.AllChecked = selectList.length === this.list.length
      this.all = selectList.length
    },
    async getList (loading = false) {
      getList(this.params, loading)
        .then(res => {
          const { current, records, pages } = res
          if (current === 1) {
            this.list = records
          } else {
            this.list = [...this.list, ...records]
          }
          if (current >= pages) {
            this.finished = true
          } else {
            this.finished = false
            this.params.current = current + 1
          }
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.refreshing = false
          this.listLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-container {
  background-color: #ffffff;
  min-height: 100vh;
}
.ad-body-box {
  background-color: #fff;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 0 12px 0 #eee;
}

.ad-menu-item {
  margin: 14px 0;
  padding: 27px 12px;
  box-shadow: 0 0 12px 0 #eee;
}
.distance {
  padding: 20px;
}
.bottom {
  margin-top: 8px;
  margin-left: 14px;
}
.distance-top {
  padding-left: 18px;
}
.line {
  width: 2px;
  height: 26px;
  background-color: #e6e6e64d;
  margin-top: 10px;
}
.distance-left {
  margin-left: 6px;
}
.distance-left-right {
  margin-left: 54px;
}
.button {
  border-radius: 100px;
  height: 50%;
  margin-top: 6px;
  background-color: #ff7307;
}
.greenDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff7307;
  box-shadow: 0 0 12px 0 #eee;
}
.redDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #2181ee;
  box-shadow: 0 0 12px 0 #eee;
}
.dot-top {
  margin-top: 26px;
}
.dot-top-text {
  margin-top: 20px;
  margin-left: 6px;
}
.dot-top-two {
  margin-top: -10px;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 0 12px 0 #eee;
}
.lineOne {
  width: 320px;
  height: 2px;
  background-color: #e6e6e64d;
  margin-top: 10px;
}
.text-over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.van-checkbox /deep/ .van-checkbox__label {
  flex: 1;
  display: flex;
  border-bottom: 1px solid $body;
  padding-bottom: 14px;
}
.nullDate {
  margin-top: 40%;
}
</style>
